import { Badge, BlockStack, Button, Checkbox, InlineGrid, InlineStack, Modal, Popover, Text, Tooltip } from '@shopify/polaris';
import { add_template, change_template, delete_template } from '../../../../../Asests/svgIcon/icon';
import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { DI, DIProps } from '../../../../../Core';
import EditNewLabel from "./EditLabel";
import AddNewLabel from './AddNewLabel';

interface Props extends DIProps {
    row: any,
    allLabels: any,
    selectedLabels: any,
    activityRefreshAction: () => void
}

import { NoteMinor } from '@shopify/polaris-icons';

interface Label {
    name: string;
}

interface LabelDisplayProps {
    selectedLabels: Label[];
    setOpenEditModal: (value: boolean) => void;
    setOpenAddModal: (value: boolean) => void;
}

const LabelDisplay: React.FC<LabelDisplayProps> = ({ selectedLabels, setOpenEditModal, setOpenAddModal }) => {
    const [popoverActive, setPopoverActive] = useState(false);
    const popoverRef = useRef<HTMLDivElement>(null);

    // Click outside handler to close popover
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (popoverRef.current && !popoverRef.current.contains(event.target as Node)) {
                setPopoverActive(false);
            }
        };

        if (popoverActive) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [popoverActive]);

    return (
        <InlineStack wrap={false} align="start" gap="150">
            {selectedLabels.length > 0 ? (
                <>
                    <BlockStack>
                        <Text as="p" variant="bodyLg">{selectedLabels[0].name}</Text>

                        {/* Show badge if more than one label exists */}
                        {selectedLabels.length > 1 && (
                            <div ref={popoverRef}>
                                <Popover
                                    active={popoverActive}
                                    activator={
                                        <Tooltip dismissOnMouseOut content="Click to see more labels">
                                            <div onClick={() => setPopoverActive(!popoverActive)}>
                                                <Badge key={selectedLabels?.[0]['name'] + Math.random()}>{`+ ${(selectedLabels.length - 1)}`}</Badge>
                                            </div>
                                        </Tooltip>
                                        // <Button variant="monochromePlain" onClick={() => setPopoverActive(!popoverActive)}>
                                        //     {(selectedLabels.length - 1) + ""}
                                        // </Button>
                                    }
                                    onClose={() => setPopoverActive(false)}
                                >
                                    <Popover.Section>
                                        <InlineStack gap="100">
                                            {selectedLabels.slice(1).map((label, index) => (
                                                <Badge key={index}>{label.name}</Badge>
                                            ))}
                                        </InlineStack>
                                    </Popover.Section>
                                </Popover>
                            </div>
                        )}
                    </BlockStack>

                    {/* Reset button */}
                    <InlineStack blockAlign="center" gap="100" align="start">
                        <Tooltip dismissOnMouseOut content="Update label">
                            <Button
                                icon={change_template}
                                variant="monochromePlain"
                                onClick={() => setOpenEditModal(true)}
                            />
                        </Tooltip>
                    </InlineStack>
                </>
            ) : (
                <InlineStack gap="200">
                    <Text as="p">N/A</Text>
                    <Tooltip dismissOnMouseOut content="Add label">
                        <Button
                            icon={add_template}
                            variant="monochromePlain"
                            onClick={() => setOpenAddModal(true)}
                        />
                    </Tooltip>
                </InlineStack>
            )}
        </InlineStack>
    );
};

function GetLabel(props: Props): ReactElement {
    const { row, allLabels, selectedLabels } = props;
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    return (
        <div className="custom-get-label__container">

            {/* {
                selectedLabels?.length && selectedLabels?.length > 0 ?
                    <InlineStack wrap={false} align='start' gap="150">
                        <Text as='p' variant='bodyLg'>{selectedLabels?.[0]?.['name']}</Text>
                        <InlineStack blockAlign='center' gap="100" align='start'>
                            <Tooltip dismissOnMouseOut content="Reset">
                                <Button
                                    icon={change_template}
                                    variant="monochromePlain"
                                    onClick={() => setOpenEditModal(true)}
                                />
                            </Tooltip>
                        </InlineStack>
                    </InlineStack>
                    :
                    <InlineGrid gap="200" columns='2'>
                        <Text as='p'>N/A</Text>
                        <Tooltip dismissOnMouseOut content="Add label">
                            <Button
                                icon={add_template}
                                variant="monochromePlain"
                                onClick={() => setOpenAddModal(true)}
                            />
                        </Tooltip>
                    </InlineGrid>
            } */}
            <LabelDisplay selectedLabels={selectedLabels} setOpenAddModal={setOpenAddModal} setOpenEditModal={setOpenEditModal} />
            <AddNewLabel open={openAddModal} setOpen={setOpenAddModal} allLabels={allLabels} selectedLabels={selectedLabels} row={row} activityRefreshAction={props.activityRefreshAction} />
            <EditNewLabel open={openEditModal} setOpen={setOpenEditModal} allLabels={allLabels} selectedLabels={selectedLabels} row={row} activityRefreshAction={props.activityRefreshAction} />
        </div >
    )
}

export default GetLabel